import React from 'react';
import { FormattedMessage } from 'react-intl';
import P from '../../../../../components/P';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
export default function DuesProtectPermissions() {
  return (
    <div>
      <Section>
        <ControlContainer>
          <P style={{ fontWeight: 'bold' }}>
            PERMISSIONS, WARRANTY AND RELEASE
          </P>
          <ol>
            <li>
            I am the authorized representative and have express permission to represent and speak for all persons in this hardship request.
            </li>
            <li>
            Any Conditions for a benefit as noted in this hardship request are an abbreviated summation for reference and not all inclusive.  Read your wavier in entirety for all terms, conditions, required procedures, and exclusions that apply.
            </li>
            <li>
            I expressly allow the program administrator for this wavier benefit, Trawick International, to request additional records from me and/or others as needed, and has my permission to directly contact the Physician(s) and/or employers, insurers, and others, as relates to this waiver request for medical, employment, insurance, and/or financial records.  Any inquiry shall be limited to seeking to verify the facts as sought under my hardship request. The program administrator may not pursue this right any more than allowed by applicable laws, or past the ability to make an informed decision on my hardship request.
            </li>
            <li>
            I understand that while a partial submission may be allowed to start my case process, no hardship request is complete until all documentation sought has been provided to the program administrator, whereupon only then will my case be evaluated for benefits.   Any failure by me or others where documentation is sought, to fully and punctually cooperate in the submission and review process, will result in a denial of my waiver request.
            </li>
            <li>
            I warrant that I understand and accept that knowingly providing false, fraudulent, or misleading information for the approval of a hardship request is a crime and may be subject to fine and/or confinement in prison.
            </li>
            <li>
            No case evaluation will be started, or my hardship request information I have entered so far be saved, if I do not sign and submit this waiver request submission now.
            </li>
          </ol>
        </ControlContainer>
      </Section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/DuesProtectPermissions/index.js